import React, { useState, useEffect } from 'react';
import './create_account.css';
import { useNavigate, useLocation } from "react-router-dom";
import { CreateAccountMobileStep3 } from './create_account_steps.mobile.js';
import { API_BASE_URL } from '../config.js';

export default function HospitalForm() {
const navigate = useNavigate();
const location = useLocation();
const prevData = location.state || {};

const specialties = [
  "طب عام",
  "طب الأسرة",
  "طب أطفال",
  "أمراض القلب",
  "طب العيون",
  "طب النساء والولادة",
  "طب الأنف والأذن والحنجرة",
  "طب الجلدية",
  "طب الأعصاب",
  "طب النفس",
  "طب العظام",
  "طب الطوارئ",
  "طب الأشعة",
  "طب الجراحة",
  "أمراض الجهاز الهضمي",
  "طب المسالك البولية",
  " أمراض الكلى",
  "أمراض الدم",
  "الأمراض الصدرية",
  "الأمراض المعدية",
  "طب الأورام",
  "جراحة قلبية",
  "جراحة عظمية",
  "جراحةعصبية",
  "جراحة تجميلية",
  "جراحة عامة",
  "أشعة",
  "مخابر",
  "تخدير",
  "علاج فيزيائي",
  "علوم الأغذية",
];

const governorates = [
  "دمشق",
  "حلب",
  "اللاذقية",
  "دير الزور",
  "إدلب",
  "حمص",
  "حماة",
  "درعا",
  "سويداء",
  "قنيطرة",
  "طرطوس",
  "الحسكة",
  "الرقة",
  "ريف دمشق",
];

// 🔹 إضافة مصفوفة المحافظات باللغة الإنجليزية بنفس الترتيب
const governorates_english = [
  "Damascus",
  "Aleppo",
  "Latakia",
  "Deir ez-Zor",
  "Idlib",
  "Homs",
  "Hama",
  "Daraa",
  "Suweida",
  "Quneitra",
  "Tartus",
  "Hasakah",
  "Raqqa",
  "Rif Dimashq",
];

const [allHospitals, setAllHospitals] = useState([]);
const [filteredHospitals, setFilteredHospitals] = useState([]);

const [formData, setFormData] = useState({
  specialty: "",
  city: "",
  hospital_id: "",
  address: "",
});

const [errors, setErrors] = useState({});
const [apiError, setApiError] = useState("");
const [loading, setLoading] = useState(false); 

const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
useEffect(() => {
  const fetchHospitals = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/registration-hospitals/`);
      if (response.ok) {
        const data = await response.json();
        setAllHospitals(data);
      }
    } catch (error) {
      console.error("Failed to fetch hospitals:", error);
    }
  };
  fetchHospitals();
}, []);

// 🔹 التحديث هنا: فلترة مزدوجة (عربي + إنجليزي) مع إزالة العناصر المتكررة
const handleCityChange = (e) => {
  const selectedCity = e.target.value; // القيمة المحددة باللغة العربية من الـ select
  setFormData({ ...formData, city: selectedCity, hospital_id: "" });
  
  if (!selectedCity) {
    setFilteredHospitals([]);
    return;
  }

  // 1. فلترة المشافي بناءً على الاسم باللغة العربية
  const filteredArabic = allHospitals.filter(h => {
    return h.city && h.city.trim().toLowerCase() === selectedCity.trim().toLowerCase();
  });

  // تحديد موقع (index) المحافظة المختارة لجلب المقابل لها بالإنجليزية
  const index = governorates.indexOf(selectedCity);
  const englishCity = index !== -1 ? governorates_english[index] : "";

  // 2. فلترة المشافي بناءً على الاسم باللغة الإنجليزية (في حال وجوده)
  const filteredEnglish = englishCity
    ? allHospitals.filter(h => h.city && h.city.trim().toLowerCase() === englishCity.trim().toLowerCase())
    : [];

  // 3. دمج المصفوفتين معاً
  const combinedHospitals = [...filteredArabic, ...filteredEnglish];

  // 4. إزالة العناصر المتكررة بناءً على الـ id الخاص بالمشفى لضمان عدم ظهور المشفى مرتين
  const uniqueHospitals = Array.from(
    new Map(combinedHospitals.map(hospital => [hospital.id, hospital])).values()
  );
  
  setFilteredHospitals(uniqueHospitals);
};

const validate = () => {
  let newErrors = {};

  if (!formData.specialty) {
    newErrors.specialty = "اختر التخصص";
  }

  if (!formData.city) {
    newErrors.city = "اختر المحافظة";
  }

  if (!formData.hospital_id) {
    newErrors.hospital_id = "اختر المشفى";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

const handleSubmit = async () => {
  if (!validate()) return;
  setApiError("");
  setLoading(true); 

  const payload = {
    username: prevData.username || "",
    real_name: prevData.name || "",
    email: prevData.email || "",
    phon_number: "0000000000", 
    password: prevData.password || "",
    password_confirm: prevData.confirmPassword || "",
    specialization: formData.specialty,
    hospital_id: parseInt(formData.hospital_id, 10)
  };

  try {
    const response = await fetch(`${API_BASE_URL}/auth/register/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (response.ok) {
      localStorage.setItem('pending_verification_user', prevData.email || prevData.username);
      navigate("/auth-verify-email");
    } else {
      let errorsList = [];
      for (const [key, val] of Object.entries(data)) {
        const fieldName = key === 'username' ? 'اسم المستخدم' : key === 'email' ? 'البريد الإلكتروني' : key;
        const messages = Array.isArray(val) ? val.join(' ') : val;
        errorsList.push(`${fieldName}: ${messages}`);
      }
      setApiError(errorsList.join(' | ') || "حدث خطأ أثناء التسجيل");
    }
  } catch (error) {
    console.error("Registration failed:", error);
    setApiError("حدث خطأ في الاتصال بالخادم");
  } finally {
    setLoading(false); 
  }
};
if (isMobile) {
    return (
      <CreateAccountMobileStep3
        formData={formData}
        setFormData={setFormData}
        errors={errors} /* إضافة */
        apiError={apiError} /* إضافة */
        loading={loading} /* إضافة */
        onSubmit={handleSubmit}
        cities={governorates}
        hospitals={filteredHospitals}
        specialties={specialties}
        onCityChange={handleCityChange}
      />
    );
  }

  return (
    <div className="create-account-container"  dir="ltr">
      <div className="create-account-left">
        <form className="create-account-form">
            <h3 className="create-account-h3">إنشاء حساب جديد</h3>
            {apiError && <div className="error-text" style={{textAlign: "center", marginBottom: "10px", width: "100%", fontSize: "13px"}}>{apiError}</div>}

            <div className="create-account-input-group">
             <i className="fa-solid fa-stethoscope create-account-icon"></i>
             <select 
               value={formData.specialty} 
               onChange={(e) => setFormData({ ...formData, specialty: e.target.value })} 
               className={errors.specialty ? "input error" : "input"}
               disabled={loading}
             >
               <option value="">اختر التخصص</option>
               {specialties.map((s, i) => (
               <option key={i} value={s}>{s} </option>))}
            </select>
           </div>

            <div className="create-account-input-group">
             <i className="fa-solid fa-city create-account-icon"></i>
             <select 
               value={formData.city} 
               onChange={handleCityChange} 
               className={errors.city ? "input error" : "input"}
               disabled={loading}
             >
              <option value="">اختر المحافظة</option>
              {governorates.map((g, i) => (
                <option key={i} value={g}>{g}</option>
              ))}
             </select>
            </div>

            <div className="create-account-input-group">
             <i className="fa-solid fa-hospital create-account-icon"></i>
             <select 
               value={formData.hospital_id} 
               onChange={(e) => setFormData({ ...formData, hospital_id: e.target.value })} 
               className={errors.hospital_id ? "input error" : "input"}
               disabled={loading}
             >
            <option value="">اختر المشفى</option>
            {filteredHospitals.map((h) => (
            <option key={h.id} value={h.id}>
            {h.name}
            </option>
           ))}
            </select>
            </div>

            <div className="create-account-input-group">
             <i className="fa-solid fa-location-dot create-account-icon"></i>
             <input 
               type="text" 
               placeholder="عنوان المشفى" 
               value={formData.address} 
               onChange={(e) => setFormData({ ...formData, address: e.target.value })}
               disabled={loading} 
             />
            </div>

            <button 
              type="button" 
              className="create-account-submit" 
              onClick={handleSubmit} 
              disabled={
                loading ||
                !formData.specialty ||
                !formData.city ||
                !formData.hospital_id
              } 
            > 
              {loading ? "جاري إنشاء الحساب وإرسال الرمز..." : "إضافة"}
            </button>        
            
        </form>
        <br></br>
        <p className="create-account-login">هل لديك حساب؟ <a href="/login">تسجيل الدخول</a></p>
      </div>

      <div className="create-account-right">
          <img className='syria-logo-create-account-logo' src="../images/Emblem_of_Syria_(2025–present).svg.png" alt="شعار الجمهورية" />
          <h1 className="create-account-title">الجمهورية العربية السورية</h1>
          <h4 className="create-account-sub">وزارة الصحة - منصة التنبؤ بالأوبئة</h4>
      </div>
    </div>
  );
}